import React, {useState} from 'react';
import {connect} from 'react-redux';

import Button from '@mui/material/Button';

import CustomDialog from '../common/CustomDialog';
import Form from '../common/Form';
import useIsMobile from '../../hooks/useIsMobile';
import * as reducer from '../../redux/reducers/calendarSettings';

const getFields = () => [
  {
    name: 'startHour',
    label: 'Start Hour',
    type: 'select',
    options: Array.from({length: 24}, (_, i) => ({
      label: `${i < 12 ? i : i - 12}:00 ${i < 12 ? 'AM' : 'PM'}`,
      value: i,
    })).filter(option => option.value > 0 && option.value < 24),
    grid: {
      xs: 6,
      md: 6,
    },
  },
  {
    name: 'endHour',
    label: 'End Hour',
    type: 'select',
    options: Array.from({length: 24}, (_, i) => ({
      label: `${i < 12 ? i : i - 12}:00 ${i < 12 ? 'AM' : 'PM'}`,
      value: i,
    })).filter(option => option.value > 0 && option.value < 24),
    grid: {
      xs: 6,
      md: 6,
    },
  },
  {
    name: 'calendarView',
    label: 'Default Calendar View',
    type: 'choice',
    options: [
      {label: 'Day', value: 'day'},
      {label: 'Week', value: 'week'},
    ],
    grid: {
      xs: 6,
      md: 6,
    },
  },
  {
    name: 'showWeekends',
    label: 'Show Weekends',
    type: 'choice',
    options: [
      {label: 'Yes', value: true},
      {label: 'No', value: false},
    ],
    grid: {
      xs: 6,
      md: 6,
    },
  },
  {
    name: 'showCancellations',
    label: 'Show Cancellations',
    type: 'choice',
    options: [
      {label: 'Yes', value: true},
      {label: 'No', value: false},
    ],
    grid: {
      xs: 6,
      md: 6,
    },
  }
];

const handleSubmit = ({
  setStartHour,
  setEndHour,
  setCalendarView,
  setShowWeekends,
  setShowCancellations,
  onClose,
}) => formData => {
  setStartHour(formData.startHour);
  setEndHour(formData.endHour);
  setCalendarView(formData.calendarView);
  setShowWeekends(formData.showWeekends);
  setShowCancellations(!!formData.showCancellations);
  onClose();
};

const CalendarSettingsButton = ({
  startHour,
  endHour,
  calendarView,
  showWeekends,
  showCancellations,
  setStartHour,
  setEndHour,
  setCalendarView,
  setShowWeekends,
  setShowCancellations,
}) => {
  console.log('CalendarSettingsButton', {startHour, endHour, calendarView, showWeekends, showCancellations: setShowCancellations});
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const isMobile = useIsMobile();
  const _calenderView = calendarView || (isMobile ? 'day' : 'week');
  return (
    <>
      <CustomDialog
        title='Calendar Settings'
        maxWidth='xs'
        isOpen={dialogIsOpen}
        onClose={() => setDialogIsOpen(false)}
      >
        <Form
          defaultValues={{
            startHour,
            endHour,
            calendarView: _calenderView,
            showWeekends,
            showCancellations: !!showCancellations,
          }}
          fields={getFields()}
          onSubmit={handleSubmit({
            setStartHour,
            setEndHour,
            setCalendarView,
            setShowWeekends,
            setShowCancellations,
            onClose: () => setDialogIsOpen(false),
          })}
        />
      </CustomDialog>
      <Button
        size='small'
        onClick={() => setDialogIsOpen(true)}
      >
        Calendar Settings
      </Button>
    </>
  );
};

const mapState = state => ({
  ...(state?.calendarSettings || {})
});

const mapDispatch = dispatch => ({
  setStartHour: (hour) => dispatch(reducer.setStartHour(hour)),
  setEndHour: (hour) => dispatch(reducer.setEndHour(hour)),
  setCalendarView: (view) => dispatch(reducer.setCalendarView(view)),
  setShowWeekends: (show) => dispatch(reducer.setShowWeekends(show)),
  setShowCancellations: (show) => dispatch(reducer.setShowCancellations(show)),
});

export default connect(mapState, mapDispatch)(CalendarSettingsButton);